// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1svYK","card":"Cards_card__2JZm0","infected":"Cards_infected__1I_Ag","recovered":"Cards_recovered__2fe3p","deaths":"Cards_deaths__2ozSO"};